/* eslint-disable @typescript-eslint/no-explicit-any */
import { checkLoginFromCookie } from '@gateio/core-utils'
import type { GetServerSidePropsResult, GetServerSidePropsContext } from 'next'

type WithAuthProps = {
  [key: string]: any
}

export type GetServerSidePropsWithAuthContext = GetServerSidePropsContext & WithAuthProps

type Callback = (context: GetServerSidePropsWithAuthContext) => Promise<GetServerSidePropsResult<any>>

export const withAuth = (fn: Callback) => {
  return async (context: GetServerSidePropsContext) => {
    if (!checkLoginFromCookie(context.req)) {
      return {
        redirect: {
          destination: '/login',
          permanent: false,
        },
      }
    }

    return await fn(context)
  }
}
